import React from 'react';
import { NavLink } from 'react-router-dom';

export interface ErrorMsgDO {
  errorStatus?: number;
  error?: { data?: { error?: { parameters?: string[] } } };
  message?: string | React.JSX.Element;
  cy?: string;
}
export default function ErrorMsg({ errorStatus, error, message, cy }: ErrorMsgDO) {
  let errorMsg: Array<string> = [];
  try {
    errorMsg = error?.data?.error?.parameters ?? [];
  } catch {
    /* empty */
  }
  const errorData = 'error-msg';
  return (
    <div
      data-tc={errorData}
      data-cy={cy ?? errorData}
      className={'row g-0 mt-5'}
    >
      <div className="col mx-auto ">
        {errorStatus === 403 ? (
          <>
            <p className={'muted-grey text-center fw-bold '}>Your session expired!</p>
            <NavLink to={'/'}>
              <p className={'muted-grey text-center fw-bold'}>Login to continue.</p>
            </NavLink>
          </>
        ) : errorStatus === 404 ? (
          <p className={' text-center fw-bold'}>Page not found!</p>
        ) : errorStatus === 67 ? (
          <p className={'text-center fw-bold invalid'}>Validation failed!</p>
        ) : (
          <p className={'muted-grey text-center fw-bold '}>Display not available at the moment.</p>
        )}

        <div className={'px-0'}>
          {errorMsg.map((item, idx) => (
            <p
              key={idx}
              className={'small p-0 m-0 invalid'}
            >
              {item}
            </p>
          ))}
          <div className="small d-flex justify-content-center muted-grey text-center fw-bold">
            {message}
          </div>
        </div>
      </div>
    </div>
  );
}
